import { TRIGGER_TYPE } from '@mindtickle/actions-dropdown';
import { ICON_MAP } from '@mindtickle/icon';

import { DEFAULT_HELP_SITE_URL, MENU_KEYS, PRIVACY_POLICY_URL } from '../../../config/constants';
import { MIXPANEL_EVENTS } from '../../../mixpanel/config';
import MenuActionLoader from '../../../../Shared/components/MenuActionLoader';
import messages from '../messages';
import { helpMenuConfigType } from '../type';
import { StyledHelpActionIcon } from '../style';

import { openChatSupport, openSupportModal, openUrl, trackAndHideAction } from './utils';

export const HELP_MENU_OPTIONS = ({
  berryActions,
  company,
  intl,
  navigate,
  onHideDropdownContent,
  track,
  user,
  isGetSupportInitialized,
  isBerryChatDisabledForAdmin,
  isChatSupportReady,
}: helpMenuConfigType) => ({
  [MENU_KEYS.HELP_SITE]: {
    disabled: false,
    displayOrder: 1,
    key: MENU_KEYS.HELP_SITE,
    triggerType: TRIGGER_TYPE.FUNCTION,
    dataTestId: 'dropdown-help-and-support-center',
    content: (
      <>
        {intl.formatMessage(messages.SEARCH_HELP_DOCUMENTATION)}
        <StyledHelpActionIcon type={ICON_MAP['NEW-TAB']} />
      </>
    ),
    callFn: () => {
      trackAndHideAction({ track, onHideDropdownContent })(MIXPANEL_EVENTS.HELP_SITE);
      openUrl(company.helpSiteUrl || DEFAULT_HELP_SITE_URL)();
    },
  },

  [MENU_KEYS.GET_SUPPORT]: {
    displayOrder: 2,
    key: MENU_KEYS.GET_SUPPORT,
    triggerType: TRIGGER_TYPE.FUNCTION,
    dataTestId: 'dropdown-report-an-issue',
    content: isGetSupportInitialized ? (
      <>{intl.formatMessage(messages.REPORT_ISSUE)}</>
    ) : (
      <MenuActionLoader />
    ),
    disabled: !isGetSupportInitialized,
    callFn: async () => {
      await openSupportModal({ navigate })();
      trackAndHideAction({ track, onHideDropdownContent })(MIXPANEL_EVENTS.GET_SUPPORT);
    },
  },

  [MENU_KEYS.CHAT_WITH_SUPPORT]: {
    displayOrder: 3,
    key: MENU_KEYS.CHAT_WITH_SUPPORT,
    triggerType: TRIGGER_TYPE.FUNCTION,
    dataTestId: 'dropdown-chat-with-support',
    content: <>{intl.formatMessage(messages.CHAT_SUPPORT)}</>,
    hide: !isChatSupportReady,
    callFn: () => {
      openChatSupport({ isBerryChatDisabledForAdmin, berryActions, user })();
      trackAndHideAction({ track, onHideDropdownContent })(MIXPANEL_EVENTS.CHAT_WITH_SUPPORT);
    },
  },

  [MENU_KEYS.PRIVACY_POLICY]: {
    displayOrder: 4,
    key: MENU_KEYS.PRIVACY_POLICY,
    triggerType: TRIGGER_TYPE.FUNCTION,
    dataTestId: 'dropdown-privacy-policy',
    content: (
      <>
        {intl.formatMessage(messages.PRIVACY_POLICY)}
        <StyledHelpActionIcon type={ICON_MAP['NEW-TAB']} />
      </>
    ),
    callFn: () => {
      openUrl(PRIVACY_POLICY_URL)();
      trackAndHideAction({ track, onHideDropdownContent })(MIXPANEL_EVENTS.PRIVACY_POLICY);
    },
  },
});
